export default __webpack_public_path__ + "static/media/330_store04-es-mobile.0738de8d.png";